import { useState } from "react";
import useGet from "../../hooks/read/useGet";
import toast from "react-hot-toast";
import usePut from "../../hooks/usePut";
import useDownloadFile from "../../hooks/useDownloadFile";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";
import RoundedContainer from "../../components/containers/RoundedContainer";
import { Button } from "../../components/ui";

const WFHApproval = () => {
  const [id, setId] = useState(null);

  const { list: applicationList } = useGet({
    url: "wfhApplicationList",
    initialData: {
      limit: 50,
    },
    onError: () => {
      toast.error(
        "There Was An Error While Fetching The Data Please Try Again Later"
      );
    },
  });

  const { handleAuth: handleWfhAction, isLoading: isSubmitting } = usePut({
    url: "wfhApproval",
    refreshUrl: "wfhApplicationList",
    onSuccess: (response) => {
      if (response.status === 200 || response.data?.status === 200) {
        toast.success("Application action successful");
      }
    },
    onError: (error) => {
      toast.error("Application failed: There was an error processing your request.");
    },
  });

  const handleAction = (wfhId, action) => {
    handleWfhAction.mutate({
      wfh_id: wfhId,
      action: action,
    });
  };

  const { reportDownload } = useDownloadFile({
    url: "wfh_report",
    onSuccess: () => {
      setId(null);
    },
    onError: () => {
      setId(null);
    },
  });

  const handleDownloadReport = async (wfhId, fromDate, toDate) => {
    setId(wfhId);
    reportDownload.mutate({
      wfh_id: wfhId,
      from_date: fromDate,
      to_date: toDate,
    });
  };

  return (
    <div className="px-4 py-10">
      <div className=" mb-4 flex items-center justify-between">
        <h1 className=" text-xl font-semibold">Remote Work Applications</h1>
      </div>

      <RoundedContainer>
        <Table className="table-auto w-full">
          <TableHead>
            <TableHeaderCell className="w-[8%] text-center">
              Sr.No
            </TableHeaderCell>
            <TableHeaderCell className="w-[18%]">
              Employee Name
            </TableHeaderCell>
            <TableHeaderCell className="w-[20%]">
              Reason
            </TableHeaderCell>
            <TableHeaderCell className="w-[14%] text-center">
              From Date
            </TableHeaderCell>
            <TableHeaderCell className="w-[14%] text-center">
              To Date
            </TableHeaderCell>
            <TableHeaderCell className="w-[12%] text-center">
              Status
            </TableHeaderCell>
            <TableHeaderCell className="w-[14%] text-center">
              Action
            </TableHeaderCell>
          </TableHead>
          <TableBody>
            {applicationList?.data?.data?.map((item, index) => (
              <TableRow
                key={index}
                className={`${item.status === "2" ? "bg-yellow-100" : ""}`}
              >
                <TableCell className="text-dark font-medium text-sm lg:text-base">
                  {index + 1}
                </TableCell>
                <TableCell className="text-dark font-medium text-sm lg:text-base">
                  {item.employee_name}
                </TableCell>
                <TableCell className="text-dark font-medium text-sm lg:text-base">
                  {item.reason}
                </TableCell>
                <TableCell className="text-dark font-medium text-sm lg:text-base">
                  {new Date(item.from_date * 1000).toLocaleDateString()}
                </TableCell>
                <TableCell className="text-dark font-medium text-sm lg:text-base">
                  {new Date(item.to_date * 1000).toLocaleDateString()}
                </TableCell>
                <TableCell className="text-dark font-medium text-sm lg:text-base align-middle">
                  <div className="flex justify-center items-center">
                    {item.status === "1" ? (
                      <span className="text-green-700 px-2 text-xs rounded-md flex items-center justify-center mr-2">
                        Approved
                      </span>
                    ) : (
                      <Button
                        onClick={() => handleAction(item.wfh_id, "APPROVE")}
                        variant="success"
                        className={"text-xs mr-2"}
                        disabled={isSubmitting}
                      >
                        Approve
                      </Button>
                    )}

                    {item.status === "3" ? (
                      <span className="text-red-700 px-2 text-xs rounded-md flex items-center justify-center mr-2">
                        Rejected
                      </span>
                    ) : (
                      <Button
                        onClick={() => handleAction(item.wfh_id, "REJECT")}
                        variant="destructive"
                        className={"text-xs"}
                        disabled={isSubmitting}
                      >
                        Reject
                      </Button>
                    )}
                  </div>
                </TableCell>
                <TableCell className=" align-middle">
                  <div className=" text-center">
                    <Button
                      type="button"
                      disabled={id === item.wfh_id}
                      onClick={() =>
                        handleDownloadReport(
                          item.wfh_id,
                          new Date(item.from_date * 1000).toLocaleDateString(),
                          new Date(item.to_date * 1000).toLocaleDateString()
                        )
                      }
                    >
                      {id === item.wfh_id
                        ? "Downloading..."
                        : "Download Report"}
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </RoundedContainer>
    </div>
  );
};

export default WFHApproval;
